import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import createMutationsSharer from "vuex-shared-mutations";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    displayName: "",
    email: "",
    userId: "",
    phNumber: "",
    address: "",
    city: "",
    currency: "",
    currencySymbol: "",
    country: "",
    postalCode: "",
    rfid: "",
    referralUrl: "",
    shortList: [],
    shortListId: [],
    shortListDocId: [],
    notifyStatus: true
  },
  mutations: {
    addDisplayName(state, newDisplayName) {
      state.displayName = newDisplayName;
    },
    addEmail(state, newEmail) {
      state.email = newEmail;
    },
    addUserId(state, newUserId) {
      state.userId = newUserId;
    },
    addPhNumber(state, newPhNumber) {
      state.phNumber = newPhNumber;
    },
    addAddress(state, newAddress) {
      state.address = newAddress;
    },
    addCity(state, newCity) {
      state.city = newCity;
    },

    addCountry(state, newCountry) {
      state.country = newCountry;
    },
    addCurrency(state, newCurrency) {
      state.currency = newCurrency;
    },
    addCurrencySymbol(state, newCurrencySymbol) {
      state.currencySymbol = newCurrencySymbol;
    },
    addPostalCode(state, newPostalCode) {
      state.postalCode = newPostalCode;
    },
    addRfid(state, newRfid) {
      state.rfid = newRfid;
    },
    addReferralUrl(state, newReferralUrl) {
      state.referralUrl = newReferralUrl;
    },
    addShortList(state, newData) {
      state.shortList.push(newData);
    },
    addShortListId(state, newData) {
      state.shortListId.push(newData);
    },
    addShortListDocId(state, newData) {
      state.shortListDocId.push(newData);
    },
    addNotifyStatus(state, newNotifyStatus) {
      state.notifyStatus = newNotifyStatus;
    },

    removeShortList(state, index) {
      state.shortList.splice(index, 1);
    },
    removeShortListDocId(state, index) {
      state.shortListDocId.splice(index, 1);
    },
    removeShortListId(state, index) {
      state.shortListId.splice(index, 1);
    },
    resetShortList(state) {
      state.shortList = [];
    },
    resetShortListId(state) {
      state.shortListId = [];
    },
    resetShortListDocId(state) {
      state.shortListDocId = [];
    },
    resetDisplayName(state) {
      state.displayName = "";
    },
    resetEmail(state) {
      state.email = "";
    },
    resetUserId(state) {
      state.userId = "";
    },
    resetPhotoUrl(state) {
      state.photoUrl = "";
    },
    resetPhNumber(state) {
      state.phNumber = "";
    },
    resetAddress(state) {
      state.address = "";
    },
    resetCity(state) {
      state.city = "";
    },
    resetCountry(state) {
      state.country = "";
    },
    resetCurrency(state) {
      state.currency = "";
    },
    resetCurrencySymbol(state) {
      state.currencySymbol = "";
    },
    resetPostalCode(state) {
      state.postalCode = "";
    },
    resetRfid(state) {
      state.rfid = "";
    },
    resetReferralUrl(state) {
      state.referralUrl = "";
    },
    resetNotifyStatus(state) {
      state.notifyStatus = true;
    }
  },
  plugins: [
    createPersistedState(),
    createMutationsSharer({
      predicate: [
        "addDisplayName",
        "addEmail",
        "addUserId",
        "addPhNumber",
        "addAddress",
        "addCity",
        "addCountry",
        "addPostalCode",
        "addCity",
        "addCountry",
        "addCurrency",
        "addCurrencySymbol",
        "addPostalCode",
        "addRfid",
        "addReferralUrl",
        "addShortList",
        "addShortListDocId",
        "addShortListId",
        "removeShortList",
        "removeShortListId",
        "removeShortListDocId",
        "resetDisplayName",
        "resetEmail",
        "resetUserId",
        "resetPhNumber",
        "resetresetress",
        "resetCity",
        "resetCountry",
        "resetPostalCode",
        "resetCity",
        "resetCountry",
        "resetCurrency",
        "resetCurrencySymbol",
        "resetPostalCode",
        "resetRfid",
        "resetReferralUrl",
        "resetShortList",
        "resetShortListId",
        "resetShortListDocId"
      ]
    })
  ],
  getters: {
    displayName: state => state.displayName,
    email: state => state.email,
    userId: state => state.userId,
    photoUrl: state => state.photoUrl,
    address: state => state.address,
    phNumber: state => state.phNumber,
    city: state => state.city,
    country: state => state.country,
    currency: state => state.currency,
    currencySymbol: state => state.currencySymbol,
    postalCode: state => state.postalCode,
    shortList: state => state.shortList,
    shortListId: state => state.shortListId,
    shortListDocId: state => state.shortListDocId,
    notifyStatus: state => state.notifyStatus,
    rfid: state => state.rfid,
    referralUrl: state => state.referralUrl
  }
});
